import { Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Collection from './pages/Collection';
import Quiz from './pages/Quiz';
import QuizRedirect from './pages/QuizRedirect';
import VoiceSelection from './pages/VoiceSelection';
import Settings from './pages/Settings';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
      <nav className="navbar navbar-dark bg-dark border-bottom fixed-top">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            10,000 Sentences
          </Link>
          <div className="navbar-nav d-flex flex-row gap-3">
            <Link to="/settings" className="nav-link">
              ⚙ <span className="d-none d-sm-inline">Settings</span>
            </Link>
            <Link to="/about" className="nav-link">
              ⓘ <span className="d-none d-sm-inline">About</span>
            </Link>
          </div>
        </div>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/collection/:id" element={<Collection />} />
        <Route path="/collection/:id/voices" element={<VoiceSelection />} />
        <Route path="/collection/:id/quiz" element={<QuizRedirect />} />
        <Route path="/collection/:collectionId/sentence/:sentenceId" element={<Quiz />} />
      </Routes>
    </>
  );
}

export default App;
